import React from "react";
import { User } from "../../../../types";

interface FilePermissionsProps {
  user: User;
  onPermissionsChange: (permissions: { files: { canDownload: boolean; canPreview: boolean } }) => void;
  disabled?: boolean;
}

const FilePermissions: React.FC<FilePermissionsProps> = ({
  user,
  onPermissionsChange,
  disabled = false,
}) => {
  const currentPermissions = user.permissions?.files || {
    canDownload: true,
    canPreview: true,
  };

  const handlePermissionChange = (permission: 'canDownload' | 'canPreview', value: boolean) => {
    const newPermissions = {
      files: {
        canDownload: currentPermissions.canDownload ?? true,
        canPreview: currentPermissions.canPreview ?? true,
        [permission]: value,
      },
    };
    onPermissionsChange(newPermissions);
  };

  return (
    <div className="space-y-4">
      <div>
        <h4 className="text-sm font-medium text-gray-900 mb-3">File Permissions</h4>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <span className="text-sm font-medium text-gray-700">Download Files</span>
              <span className="text-xs text-gray-500">Allow user to download files</span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only"
                checked={currentPermissions.canDownload ?? true}
                onChange={(e) => handlePermissionChange('canDownload', e.target.checked)}
                disabled={disabled}
              />
              <div className={`w-11 h-6 rounded-full transition-colors duration-200 ease-in-out ${
                currentPermissions.canDownload ? 'bg-violet-600' : 'bg-gray-300'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
                <div className={`inline-block w-4 h-4 rounded-full bg-white transition-transform duration-200 ease-in-out transform ${
                  currentPermissions.canDownload ? 'translate-x-6' : 'translate-x-1'
                } mt-1`} />
              </div>
            </label>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <span className="text-sm font-medium text-gray-700">Preview Files</span>
              <span className="text-xs text-gray-500">Allow user to preview files</span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only"
                checked={currentPermissions.canPreview ?? true}
                onChange={(e) => handlePermissionChange('canPreview', e.target.checked)}
                disabled={disabled}
              />
              <div className={`w-11 h-6 rounded-full transition-colors duration-200 ease-in-out ${
                currentPermissions.canPreview ? 'bg-violet-600' : 'bg-gray-300'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
                <div className={`inline-block w-4 h-4 rounded-full bg-white transition-transform duration-200 ease-in-out transform ${
                  currentPermissions.canPreview ? 'translate-x-6' : 'translate-x-1'
                } mt-1`} />
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilePermissions;